const useCurrentSessionID = () => {
    const current_session_ID = document.getElementById("current_session_ID")
    return current_session_ID.textContent
}

export default useCurrentSessionID